module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [(!_vm.showRecipes) ? _c('section', [_c('h3', {
    staticClass: "section-title section-title__test"
  }, [_vm._v("Тест")]), _vm._v(" "), (this.testNum <= 5) ? _c('div', {
    staticClass: "test-container valign"
  }, [_vm._m(0), _vm._v(" "), (this.testNum == 1) ? _c('div', {
    staticClass: "test-answer clearfix active",
    attrs: {
      "data-number": "1"
    }
  }, [_c('a', {
    staticClass: "test-item left",
    attrs: {
      "href": "#"
    },
    on: {
      "click": function($event) {
        $event.preventDefault();
        _vm.selectAnswer(0)
      }
    }
  }, [_c('span', {
    staticClass: "test-image"
  }), _vm._v(" "), _c('span', {
    staticClass: "test-text"
  }, [_vm._v("Ананас на гриле")])]), _vm._v(" "), _c('a', {
    staticClass: "test-item left",
    attrs: {
      "href": "#"
    },
    on: {
      "click": function($event) {
        $event.preventDefault();
        _vm.selectAnswer(10)
      }
    }
  }, [_c('span', {
    staticClass: "test-image"
  }), _vm._v(" "), _c('span', {
    staticClass: "test-text"
  }, [_vm._v("Говяжьи шашлычки")])])]) : _vm._e(), _vm._v(" "), (this.testNum == 2) ? _c('div', {
    staticClass: "test-answer clearfix active",
    attrs: {
      "data-number": "2"
    }
  }, [_c('a', {
    staticClass: "test-item left",
    attrs: {
      "href": "#"
    },
    on: {
      "click": function($event) {
        $event.preventDefault();
        _vm.selectAnswer(0)
      }
    }
  }, [_c('span', {
    staticClass: "test-image"
  }), _vm._v(" "), _c('span', {
    staticClass: "test-text"
  }, [_vm._v("Порей с чесночным майонезом")])]), _vm._v(" "), _c('a', {
    staticClass: "test-item left",
    attrs: {
      "href": "#"
    },
    on: {
      "click": function($event) {
        $event.preventDefault();
        _vm.selectAnswer(10)
      }
    }
  }, [_c('span', {
    staticClass: "test-image"
  }), _vm._v(" "), _c('span', {
    staticClass: "test-text"
  }, [_vm._v("Ягненок тандури")])])]) : _vm._e(), _vm._v(" "), (this.testNum == 3) ? _c('div', {
    staticClass: "test-answer clearfix active",
    attrs: {
      "data-number": "3"
    }
  }, [_c('a', {
    staticClass: "test-item left",
    attrs: {
      "href": "#"
    },
    on: {
      "click": function($event) {
        $event.preventDefault();
        _vm.selectAnswer(0)
      }
    }
  }, [_c('span', {
    staticClass: "test-image"
  }), _vm._v(" "), _c('span', {
    staticClass: "test-text"
  }, [_vm._v("Персики на гриле с горгонзолой и медом")])]), _vm._v(" "), _c('a', {
    staticClass: "test-item left",
    attrs: {
      "href": "#"
    },
    on: {
      "click": function($event) {
        $event.preventDefault();
        _vm.selectAnswer(10)
      }
    }
  }, [_c('span', {
    staticClass: "test-image"
  }), _vm._v(" "), _c('span', {
    staticClass: "test-text"
  }, [_vm._v("Сэндвич с яичницей")])])]) : _vm._e(), _vm._v(" "), (this.testNum == 4) ? _c('div', {
    staticClass: "test-answer clearfix active",
    attrs: {
      "data-number": "4"
    }
  }, [_c('a', {
    staticClass: "test-item left",
    attrs: {
      "href": "#"
    },
    on: {
      "click": function($event) {
        $event.preventDefault();
        _vm.selectAnswer(0)
      }
    }
  }, [_c('span', {
    staticClass: "test-image"
  }), _vm._v(" "), _c('span', {
    staticClass: "test-text"
  }, [_vm._v("Дорада на гриле с мандаринами и майораном")])]), _vm._v(" "), _c('a', {
    staticClass: "test-item left",
    attrs: {
      "href": "#"
    },
    on: {
      "click": function($event) {
        $event.preventDefault();
        _vm.selectAnswer(10)
      }
    }
  }, [_c('span', {
    staticClass: "test-image"
  }), _vm._v(" "), _c('span', {
    staticClass: "test-text"
  }, [_vm._v("Шаверма в пите")])])]) : _vm._e(), _vm._v(" "), (this.testNum == 5) ? _c('div', {
    staticClass: "test-answer clearfix active",
    attrs: {
      "data-number": "5"
    }
  }, [_c('a', {
    staticClass: "test-item left",
    attrs: {
      "href": "#"
    },
    on: {
      "click": function($event) {
        $event.preventDefault();
        _vm.selectAnswer(0)
      }
    }
  }, [_c('span', {
    staticClass: "test-image"
  }), _vm._v(" "), _c('span', {
    staticClass: "test-text"
  }, [_vm._v("Зажаренная на гриле капуста")])]), _vm._v(" "), _c('a', {
    staticClass: "test-item left",
    attrs: {
      "href": "#"
    },
    on: {
      "click": function($event) {
        $event.preventDefault();
        _vm.selectAnswer(10)
      }
    }
  }, [_c('span', {
    staticClass: "test-image"
  }), _vm._v(" "), _c('span', {
    staticClass: "test-text"
  }, [_vm._v("Цыпленок гриль с орегано")])])]) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "test-progress"
  }, [_c('span', {
    class: [this.testNum === 1 ? 'active' : '', '', this.testNum > 1 ? 'done' : '', '']
  }, [_vm._v("1")]), _vm._v(" "), _c('span', {
    class: [this.testNum === 2 ? 'active' : '', '', this.testNum > 2 ? 'done' : '', '']
  }, [_vm._v("2")]), _vm._v(" "), _c('span', {
    class: [this.testNum === 3 ? 'active' : '', '', this.testNum > 3 ? 'done' : '', '']
  }, [_vm._v("3")]), _vm._v(" "), _c('span', {
    class: [this.testNum === 4 ? 'active' : '', '', this.testNum > 4 ? 'done' : '', '']
  }, [_vm._v("4")]), _vm._v(" "), _c('span', {
    class: [this.testNum === 5 ? 'active' : '', '']
  }, [_vm._v("5")])])]) : _vm._e(), _vm._v(" "), (this.testNum > 5 && this.bal > 30) ? [_c('div', {
    staticClass: "text-container text-container__result valign"
  }, [_c('div', {
    staticClass: "result-top"
  }, [_c('h3', {
    staticClass: "text-title"
  }, [_vm._v("Будьте внимательнее!")]), _vm._v(" "), _vm._m(1), _vm._v(" "), _c('div', {
    staticClass: "social-wrapper"
  }, [_c('social-sharing', {
    staticClass: "social",
    attrs: {
      "url": "http://baktistatin.eda.ru/share-1.html"
    },
    inlineTemplate: {
      render: function() {
        var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
          return _c('div', [_c('a', {
            staticClass: "fb",
            attrs: {
              "href": "#"
            }
          }, [_c('network', {
            attrs: {
              "network": "facebook"
            }
          }, [_c('img', {
            attrs: {
              "src": "/static/svg/fb.svg",
              "alt": "Facebook"
            }
          })])], 1), _vm._v(" "), _c('a', {
            staticClass: "tw",
            attrs: {
              "href": "#"
            }
          }, [_c('network', {
            attrs: {
              "network": "twitter"
            }
          }, [_c('img', {
            attrs: {
              "src": "/static/svg/twitter.svg",
              "alt": "Twitter"
            }
          })])], 1), _vm._v(" "), _c('a', {
            staticClass: "vk",
            attrs: {
              "href": "#"
            }
          }, [_c('network', {
            attrs: {
              "network": "vk"
            }
          }, [_c('img', {
            attrs: {
              "src": "/static/svg/vk.svg",
              "alt": "Vkontakte"
            }
          })])], 1)])
        
      },
      staticRenderFns: []
    }
  }), _vm._v(" "), _c('a', {
    staticClass: "ok",
    attrs: {
      "href": "#"
    },
    on: {
      "click": function($event) {
        $event.preventDefault();
        _vm.shareOk($event)
      }
    }
  }, [_vm._m(2)])], 1)]), _vm._v(" "), _c('div', {
    staticClass: "result-bottom clearfix"
  }, [_c('div', {
    staticClass: "text-main"
  }, [_c('p', [_vm._v("Позаботьтесь об этом заранее – храните БАКТИСТАТИН ® при себе!")]), _vm._v(" "), _c('span', [_vm._v("узнать больше")]), _c('Arrow')], 1), _vm._v(" "), _c('div', {
    staticClass: "image-right"
  }, [_c('a', {
    attrs: {
      "href": "http://www.bactistatin.com/about/",
      "target": "_blank"
    },
    on: {
      "click": _vm.gaRedirect
    }
  }, [_c('img', {
    attrs: {
      "src": "/static/images/baktistatin.png",
      "alt": "Baktistatin"
    }
  })]), _vm._v(" "), _c('img', {
    staticClass: "shadow",
    attrs: {
      "src": "/static/images/shadow.png",
      "alt": "Baktistatin"
    }
  })])]), _vm._v(" "), _c('a', {
    staticClass: "btn btn-hover",
    attrs: {
      "href": "#"
    },
    on: {
      "click": function($event) {
        $event.preventDefault();
        _vm.recShow($event)
      }
    }
  }, [_c('span', [_vm._v("далее")])])])] : _vm._e(), _vm._v(" "), (this.testNum > 5 && this.bal > 10 && this.bal <= 30) ? [_c('div', {
    staticClass: "text-container text-container__result valign"
  }, [_c('div', {
    staticClass: "result-top"
  }, [_c('h3', {
    staticClass: "text-title"
  }, [_vm._v("Неплохой результат!")]), _vm._v(" "), _vm._m(3), _vm._v(" "), _c('div', {
    staticClass: "social-wrapper"
  }, [_c('social-sharing', {
    staticClass: "social",
    attrs: {
      "url": "http://baktistatin.eda.ru/share-2.html"
    },
    inlineTemplate: {
      render: function() {
        var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
          return _c('div', [_c('a', {
            staticClass: "fb",
            attrs: {
              "href": "#"
            }
          }, [_c('network', {
            attrs: {
              "network": "facebook"
            }
          }, [_c('img', {
            attrs: {
              "src": "/static/svg/fb.svg",
              "alt": "Facebook"
            }
          })])], 1), _vm._v(" "), _c('a', {
            staticClass: "tw",
            attrs: {
              "href": "#"
            }
          }, [_c('network', {
            attrs: {
              "network": "twitter"
            }
          }, [_c('img', {
            attrs: {
              "src": "/static/svg/twitter.svg",
              "alt": "Twitter"
            }
          })])], 1), _vm._v(" "), _c('a', {
            staticClass: "vk",
            attrs: {
              "href": "#"
            }
          }, [_c('network', {
            attrs: {
              "network": "vk"
            }
          }, [_c('img', {
            attrs: {
              "src": "/static/svg/vk.svg",
              "alt": "Vkontakte"
            }
          })])], 1)])
        
      },
      staticRenderFns: []
    }
  }), _vm._v(" "), _c('a', {
    staticClass: "ok",
    attrs: {
      "href": "#"
    },
    on: {
      "click": function($event) {
        $event.preventDefault();
        _vm.shareOk($event)
      }
    }
  }, [_vm._m(4)])], 1)]), _vm._v(" "), _c('div', {
    staticClass: "result-bottom clearfix"
  }, [_c('div', {
    staticClass: "text-main"
  }, [_c('p', [_vm._v("Поэтому, возьмите с собой на выходные упаковку препарата БАКТИСТАТИН ®.")]), _vm._v(" "), _c('span', [_vm._v("узнать больше")]), _c('Arrow')], 1), _vm._v(" "), _c('div', {
    staticClass: "image-right"
  }, [_c('a', {
    attrs: {
      "href": "http://www.bactistatin.com/about/",
      "target": "_blank"
    },
    on: {
      "click": _vm.gaRedirect
    }
  }, [_c('img', {
    attrs: {
      "src": "/static/images/baktistatin.png",
      "alt": "Baktistatin"
    }
  })]), _vm._v(" "), _c('img', {
    staticClass: "shadow",
    attrs: {
      "src": "/static/images/shadow.png",
      "alt": "Baktistatin"
    }
  })])]), _vm._v(" "), _c('a', {
    staticClass: "btn btn-hover",
    attrs: {
      "href": "#"
    },
    on: {
      "click": function($event) {
        $event.preventDefault();
        _vm.recShow($event)
      }
    }
  }, [_c('span', [_vm._v("далее")])])])] : _vm._e(), _vm._v(" "), (this.testNum > 5 && this.bal <= 10) ? [_c('div', {
    staticClass: "text-container text-container__result valign"
  }, [_c('div', {
    staticClass: "result-top"
  }, [_c('h3', {
    staticClass: "text-title"
  }, [_vm._v("Хороший результат!")]), _vm._v(" "), _vm._m(5), _vm._v(" "), _c('div', {
    staticClass: "social-wrapper"
  }, [_c('social-sharing', {
    staticClass: "social",
    attrs: {
      "url": "http://baktistatin.eda.ru/share-3.html"
    },
    inlineTemplate: {
      render: function() {
        var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
          return _c('div', [_c('a', {
            staticClass: "fb",
            attrs: {
              "href": "#"
            }
          }, [_c('network', {
            attrs: {
              "network": "facebook"
            }
          }, [_c('img', {
            attrs: {
              "src": "/static/svg/fb.svg",
              "alt": "Facebook"
            }
          })])], 1), _vm._v(" "), _c('a', {
            staticClass: "tw",
            attrs: {
              "href": "#"
            }
          }, [_c('network', {
            attrs: {
              "network": "twitter"
            }
          }, [_c('img', {
            attrs: {
              "src": "/static/svg/twitter.svg",
              "alt": "Twitter"
            }
          })])], 1), _vm._v(" "), _c('a', {
            staticClass: "vk",
            attrs: {
              "href": "#"
            }
          }, [_c('network', {
            attrs: {
              "network": "vk"
            }
          }, [_c('img', {
            attrs: {
              "src": "/static/svg/vk.svg",
              "alt": "Vkontakte"
            }
          })])], 1)])
        
      },
      staticRenderFns: []
    }
  }), _vm._v(" "), _c('a', {
    staticClass: "ok",
    attrs: {
      "href": "#"
    },
    on: {
      "click": function($event) {
        $event.preventDefault();
        _vm.shareOk($event)
      }
    }
  }, [_vm._m(6)])], 1)]), _vm._v(" "), _c('div', {
    staticClass: "result-bottom clearfix"
  }, [_c('div', {
    staticClass: "text-main"
  }, [_c('p', [_vm._v("Лучше иметь БАКТИСТАТИН ®\n                            под рукой для себя или увлекающихся BBQ близких.")]), _vm._v(" "), _c('span', [_vm._v("узнать больше")]), _c('Arrow')], 1), _vm._v(" "), _c('div', {
    staticClass: "image-right"
  }, [_c('a', {
    attrs: {
      "href": "http://www.bactistatin.com/about/",
      "target": "_blank"
    },
    on: {
      "click": _vm.gaRedirect
    }
  }, [_c('img', {
    attrs: {
      "src": "/static/images/baktistatin.png",
      "alt": "Baktistatin"
    }
  })]), _vm._v(" "), _c('img', {
    staticClass: "shadow",
    attrs: {
      "src": "/static/images/shadow.png",
      "alt": "Baktistatin"
    }
  })])]), _vm._v(" "), _c('a', {
    staticClass: "btn btn-hover",
    attrs: {
      "href": "#"
    },
    on: {
      "click": function($event) {
        $event.preventDefault();
        _vm.recShow($event)
      }
    }
  }, [_c('span', [_vm._v("далее")])])])] : _vm._e()], 2) : _vm._e(), _vm._v(" "), (_vm.showRecipes) ? _c('section', {
    staticClass: "scrollable"
  }, [_c('h3', {
    staticClass: "section-title"
  }, [_vm._v("Рецепты")]), _vm._v(" "), _vm._m(7), _vm._v(" "), (this.bal > 30) ? _c('div', {
    staticClass: "recipes-wrap"
  }, [_c('div', {
    staticClass: "recipes-container"
  }, [_c('div', {
    staticClass: "recipes-col"
  }, [_c('div', {
    staticClass: "recipes-item"
  }, [_c('router-link', {
    attrs: {
      "to": {
        name: 'Recipe',
        params: {
          id: 11
        }
      }
    }
  }), _vm._v(" "), _c('img', {
    attrs: {
      "src": _vm.RecipeItem[11].image,
      "alt": ""
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "recipes-info"
  }, [_c('span', {
    staticClass: "recipes-num recipes-num-round"
  }, [_vm._v("1")]), _vm._v(" "), _c('span', {
    staticClass: "recipes-name"
  }, [_vm._v(_vm._s(_vm.RecipeItem[11].name))]), _vm._v(" "), _c('span', {
    staticClass: "recipes-portions"
  }, [_vm._v(_vm._s(_vm.RecipeItem[11].portion))]), _vm._v(" "), _c('span', {
    staticClass: "recipes-time"
  }, [_vm._v(_vm._s(_vm.RecipeItem[11].time))])])], 1), _vm._v(" "), _c('div', {
    staticClass: "recipes-item"
  }, [_c('router-link', {
    attrs: {
      "to": {
        name: 'Recipe',
        params: {
          id: 13
        }
      }
    }
  }), _vm._v(" "), _c('img', {
    attrs: {
      "src": _vm.RecipeItem[13].image,
      "alt": ""
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "recipes-info"
  }, [_c('span', {
    staticClass: "recipes-num recipes-num-round"
  }, [_vm._v("3")]), _vm._v(" "), _c('span', {
    staticClass: "recipes-name"
  }, [_vm._v(_vm._s(_vm.RecipeItem[13].name))]), _vm._v(" "), _c('span', {
    staticClass: "recipes-portions"
  }, [_vm._v(_vm._s(_vm.RecipeItem[13].portion))]), _vm._v(" "), _c('span', {
    staticClass: "recipes-time"
  }, [_vm._v(_vm._s(_vm.RecipeItem[13].time))])])], 1)]), _vm._v(" "), _c('div', {
    staticClass: "recipes-col"
  }, [_c('div', {
    staticClass: "recipes-item"
  }, [_c('router-link', {
    attrs: {
      "to": {
        name: 'Recipe',
        params: {
          id: 17
        }
      }
    }
  }), _vm._v(" "), _c('img', {
    attrs: {
      "src": _vm.RecipeItem[17].image,
      "alt": ""
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "recipes-info"
  }, [_c('span', {
    staticClass: "recipes-num recipes-num-round"
  }, [_vm._v("2")]), _vm._v(" "), _c('span', {
    staticClass: "recipes-name"
  }, [_vm._v(_vm._s(_vm.RecipeItem[17].name))]), _vm._v(" "), _c('span', {
    staticClass: "recipes-portions"
  }, [_vm._v(_vm._s(_vm.RecipeItem[17].portion))]), _vm._v(" "), _c('span', {
    staticClass: "recipes-time"
  }, [_vm._v(_vm._s(_vm.RecipeItem[17].time))])])], 1), _vm._v(" "), _c('div', {
    staticClass: "recipes-item"
  }, [_c('router-link', {
    attrs: {
      "to": {
        name: 'Recipe',
        params: {
          id: 18
        }
      }
    }
  }), _vm._v(" "), _c('img', {
    attrs: {
      "src": _vm.RecipeItem[18].image,
      "alt": ""
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "recipes-info"
  }, [_c('span', {
    staticClass: "recipes-num recipes-num-round"
  }, [_vm._v("4")]), _vm._v(" "), _c('span', {
    staticClass: "recipes-name"
  }, [_vm._v(_vm._s(_vm.RecipeItem[18].name))]), _vm._v(" "), _c('span', {
    staticClass: "recipes-portions"
  }, [_vm._v(_vm._s(_vm.RecipeItem[18].portion))]), _vm._v(" "), _c('span', {
    staticClass: "recipes-time"
  }, [_vm._v(_vm._s(_vm.RecipeItem[18].time))])])], 1)])]), _vm._v(" "), _c('div', {
    staticClass: "recipe-button"
  }, [_c('router-link', {
    staticClass: "btn btn-hover",
    attrs: {
      "to": "/recipes"
    },
    nativeOn: {
      "click": function($event) {
        _vm.gaMore($event)
      }
    }
  }, [_c('span', [_vm._v("больше рецептов")])])], 1)]) : _vm._e(), _vm._v(" "), (this.bal > 10 && this.bal <= 30) ? _c('div', {
    staticClass: "recipes-wrap"
  }, [_c('div', {
    staticClass: "recipes-container"
  }, [_c('div', {
    staticClass: "recipes-col"
  }, [_c('div', {
    staticClass: "recipes-item"
  }, [_c('router-link', {
    attrs: {
      "to": {
        name: 'Recipe',
        params: {
          id: 3
        }
      }
    }
  }), _vm._v(" "), _c('img', {
    attrs: {
      "src": _vm.RecipeItem[3].image,
      "alt": ""
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "recipes-info"
  }, [_c('span', {
    staticClass: "recipes-num recipes-num-round"
  }, [_vm._v("1")]), _vm._v(" "), _c('span', {
    staticClass: "recipes-name"
  }, [_vm._v(_vm._s(_vm.RecipeItem[3].name))]), _vm._v(" "), _c('span', {
    staticClass: "recipes-portions"
  }, [_vm._v(_vm._s(_vm.RecipeItem[3].portion))]), _vm._v(" "), _c('span', {
    staticClass: "recipes-time"
  }, [_vm._v(_vm._s(_vm.RecipeItem[3].time))])])], 1), _vm._v(" "), _c('div', {
    staticClass: "recipes-item"
  }, [_c('router-link', {
    attrs: {
      "to": {
        name: 'Recipe',
        params: {
          id: 8
        }
      }
    }
  }), _vm._v(" "), _c('img', {
    attrs: {
      "src": _vm.RecipeItem[8].image,
      "alt": ""
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "recipes-info"
  }, [_c('span', {
    staticClass: "recipes-num recipes-num-round"
  }, [_vm._v("3")]), _vm._v(" "), _c('span', {
    staticClass: "recipes-name"
  }, [_vm._v(_vm._s(_vm.RecipeItem[8].name))]), _vm._v(" "), _c('span', {
    staticClass: "recipes-portions"
  }, [_vm._v(_vm._s(_vm.RecipeItem[8].portion))]), _vm._v(" "), _c('span', {
    staticClass: "recipes-time"
  }, [_vm._v(_vm._s(_vm.RecipeItem[8].time))])])], 1)]), _vm._v(" "), _c('div', {
    staticClass: "recipes-col"
  }, [_c('div', {
    staticClass: "recipes-item"
  }, [_c('router-link', {
    attrs: {
      "to": {
        name: 'Recipe',
        params: {
          id: 11
        }
      }
    }
  }), _vm._v(" "), _c('img', {
    attrs: {
      "src": _vm.RecipeItem[11].image,
      "alt": ""
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "recipes-info"
  }, [_c('span', {
    staticClass: "recipes-num recipes-num-round"
  }, [_vm._v("2")]), _vm._v(" "), _c('span', {
    staticClass: "recipes-name"
  }, [_vm._v(_vm._s(_vm.RecipeItem[11].name))]), _vm._v(" "), _c('span', {
    staticClass: "recipes-portions"
  }, [_vm._v(_vm._s(_vm.RecipeItem[11].portion))]), _vm._v(" "), _c('span', {
    staticClass: "recipes-time"
  }, [_vm._v(_vm._s(_vm.RecipeItem[11].time))])])], 1), _vm._v(" "), _c('div', {
    staticClass: "recipes-item"
  }, [_c('router-link', {
    attrs: {
      "to": {
        name: 'Recipe',
        params: {
          id: 17
        }
      }
    }
  }), _vm._v(" "), _c('img', {
    attrs: {
      "src": _vm.RecipeItem[17].image,
      "alt": ""
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "recipes-info"
  }, [_c('span', {
    staticClass: "recipes-num recipes-num-round"
  }, [_vm._v("4")]), _vm._v(" "), _c('span', {
    staticClass: "recipes-name"
  }, [_vm._v(_vm._s(_vm.RecipeItem[17].name))]), _vm._v(" "), _c('span', {
    staticClass: "recipes-portions"
  }, [_vm._v(_vm._s(_vm.RecipeItem[17].portion))]), _vm._v(" "), _c('span', {
    staticClass: "recipes-time"
  }, [_vm._v(_vm._s(_vm.RecipeItem[17].time))])])], 1)])]), _vm._v(" "), _c('div', {
    staticClass: "recipe-button"
  }, [_c('router-link', {
    staticClass: "btn btn-hover",
    attrs: {
      "to": "/recipes"
    },
    nativeOn: {
      "click": function($event) {
        _vm.gaMore($event)
      }
    }
  }, [_c('span', [_vm._v("больше рецептов")])])], 1)]) : _vm._e(), _vm._v(" "), (this.bal <= 10) ? _c('div', {
    staticClass: "recipes-wrap"
  }, [_c('div', {
    staticClass: "recipes-container"
  }, [_c('div', {
    staticClass: "recipes-col"
  }, [_c('div', {
    staticClass: "recipes-item"
  }, [_c('router-link', {
    attrs: {
      "to": {
        name: 'Recipe',
        params: {
          id: 1
        }
      }
    }
  }), _vm._v(" "), _c('img', {
    attrs: {
      "src": _vm.RecipeItem[1].image,
      "alt": ""
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "recipes-info"
  }, [_c('span', {
    staticClass: "recipes-num recipes-num-round"
  }, [_vm._v("1")]), _vm._v(" "), _c('span', {
    staticClass: "recipes-name"
  }, [_vm._v(_vm._s(_vm.RecipeItem[1].name))]), _vm._v(" "), _c('span', {
    staticClass: "recipes-portions"
  }, [_vm._v(_vm._s(_vm.RecipeItem[1].portion))]), _vm._v(" "), _c('span', {
    staticClass: "recipes-time"
  }, [_vm._v(_vm._s(_vm.RecipeItem[1].time))])])], 1), _vm._v(" "), _c('div', {
    staticClass: "recipes-item"
  }, [_c('router-link', {
    attrs: {
      "to": {
        name: 'Recipe',
        params: {
          id: 2
        }
      }
    }
  }), _vm._v(" "), _c('img', {
    attrs: {
      "src": _vm.RecipeItem[2].image,
      "alt": ""
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "recipes-info"
  }, [_c('span', {
    staticClass: "recipes-num recipes-num-round"
  }, [_vm._v("3")]), _vm._v(" "), _c('span', {
    staticClass: "recipes-name"
  }, [_vm._v(_vm._s(_vm.RecipeItem[2].name))]), _vm._v(" "), _c('span', {
    staticClass: "recipes-portions"
  }, [_vm._v(_vm._s(_vm.RecipeItem[2].portion))]), _vm._v(" "), _c('span', {
    staticClass: "recipes-time"
  }, [_vm._v(_vm._s(_vm.RecipeItem[2].time))])])], 1)]), _vm._v(" "), _c('div', {
    staticClass: "recipes-col"
  }, [_c('div', {
    staticClass: "recipes-item"
  }, [_c('router-link', {
    attrs: {
      "to": {
        name: 'Recipe',
        params: {
          id: 3
        }
      }
    }
  }), _vm._v(" "), _c('img', {
    attrs: {
      "src": _vm.RecipeItem[3].image,
      "alt": ""
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "recipes-info"
  }, [_c('span', {
    staticClass: "recipes-num recipes-num-round"
  }, [_vm._v("2")]), _vm._v(" "), _c('span', {
    staticClass: "recipes-name"
  }, [_vm._v(_vm._s(_vm.RecipeItem[3].name))]), _vm._v(" "), _c('span', {
    staticClass: "recipes-portions"
  }, [_vm._v(_vm._s(_vm.RecipeItem[3].portion))]), _vm._v(" "), _c('span', {
    staticClass: "recipes-time"
  }, [_vm._v(_vm._s(_vm.RecipeItem[3].time))])])], 1), _vm._v(" "), _c('div', {
    staticClass: "recipes-item"
  }, [_c('router-link', {
    attrs: {
      "to": {
        name: 'Recipe',
        params: {
          id: 8
        }
      }
    }
  }), _vm._v(" "), _c('img', {
    attrs: {
      "src": _vm.RecipeItem[8].image,
      "alt": ""
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "recipes-info"
  }, [_c('span', {
    staticClass: "recipes-num recipes-num-round"
  }, [_vm._v("4")]), _vm._v(" "), _c('span', {
    staticClass: "recipes-name"
  }, [_vm._v(_vm._s(_vm.RecipeItem[8].name))]), _vm._v(" "), _c('span', {
    staticClass: "recipes-portions"
  }, [_vm._v(_vm._s(_vm.RecipeItem[8].portion))]), _vm._v(" "), _c('span', {
    staticClass: "recipes-time"
  }, [_vm._v(_vm._s(_vm.RecipeItem[8].time))])])], 1)])]), _vm._v(" "), _c('div', {
    staticClass: "recipe-button"
  }, [_c('router-link', {
    staticClass: "btn btn-hover",
    attrs: {
      "to": "/recipes"
    },
    nativeOn: {
      "click": function($event) {
        _vm.gaMore($event)
      }
    }
  }, [_c('span', [_vm._v("больше рецептов")])])], 1)]) : _vm._e()]) : _vm._e()])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "text-container text-container__test"
  }, [_c('div', {
    staticClass: "text-main"
  }, [_c('p', [_vm._v("\n                        Из нескольких пар блюд, приготовленных на гриле, выберите те, которые вам больше нравятся.\n                        По результатам теста мы расскажем, как часто вы можете устраивать и посещать BBQ-мероприятия без последствий для вашего организма.\n                    ")])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "text-main"
  }, [_c('p', [_vm._v("\n                            Судя по вашим кулинарным предпочтениям, вашему кишечнику понадобится помощь уже на второй день выходных.\n                        ")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('span', [_c('img', {
    attrs: {
      "src": "/static/svg/ok.svg",
      "alt": "Ok"
    }
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "text-main"
  }, [_c('p', [_vm._v("\n                            Похоже, что ваше меню на выходные находится в разумном балансе между сытостью и полезностью. Однако не стоит забывать, что и при таком режиме ваш кишечник может перетрудиться.\n                        ")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('span', [_c('img', {
    attrs: {
      "src": "/static/svg/ok.svg",
      "alt": "Ok"
    }
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "text-main"
  }, [_c('p', [_vm._v("\n                            Вы сможете провести почти месяц BBQ сезона без последствий для кишечника. Однако, потом вам все равно потребуется период восстановления.\n                        ")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('span', [_c('img', {
    attrs: {
      "src": "/static/svg/ok.svg",
      "alt": "Ok"
    }
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "text-container text-container-relative"
  }, [_c('h3', {
    staticClass: "text-title"
  }, [_vm._v("Мы подобрали рецепты на твой вкус:")])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-310cc3d1"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/pages/TestMain.vue
// module id = 96
// module chunks = 0